import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { InvoiceType, ReactQueryKey } from "../../../../../types";
import { useWatch } from "react-hook-form";
import { IFormValues } from "../../../types";
import React from "react";
import { FormAutocomplete } from "../../../../../components/fields";
import { getCountries } from "../../../../../api/services";

const BirthNationField = (props: any) => {
    const { t } = useTranslation('booking');

    const countriesQuery = useQuery({
        queryKey: [ReactQueryKey.Countries],
        queryFn: getCountries,
        refetchOnMount: false
    });

    const invoiceId = useWatch<IFormValues, 'invoice.id'>({
        name: 'invoice.id'
    });
    const invoiceType = useWatch<IFormValues, "invoice.type">({
        name: 'invoice.type'
    });

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.birthNation"
            label={t('label.countryOfBirth') + (invoiceType === InvoiceType.VAT_NUMBER_HOLDER ? '*' : '')}
            options={countriesQuery.data ?? []}
            disabled={!!invoiceId || props.birthNationDisabled}
        />
    );
}

export default BirthNationField;
